
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  reactive,
  toRefs,
} from "vue";
import {
  getMessageListApi,
  readMessageListApi,
} from "../../../api/farmerSpace";
import { StateType } from "./messageListType";
import { initCreateFn } from "@/utils/util";
import Throttle from "../../utils/throttle";
import { useRouter } from "vue-router";
import Storage from "@/storage/Storage";
import { Notify } from "vant";
import mitt from "@/utils/mitt";
let throttle: Throttle;
function getState(): StateType {
  return {
    page: 1,
    pageSize: 10,
    messageList: [],
    dataTotal: 0,
  };
}
export default defineComponent({
  setup() {
    const state = reactive<StateType>(getState());
    const router = useRouter();
    const { getMessageData } = useDatas(state);
    const tempStorageData = Storage.get("tempMessageData");
    // 缓存中存在临时数据时，优先取缓存中的数据，tempMessageData中的数据是为了进入其他页面后返回回来时保留在原本的位置
    if (tempStorageData) {
      state.messageList = tempStorageData.datas;
      window.scrollTo(0, tempStorageData.top);
      Storage.remove("tempMessageData")
    } else {
      
      getMessageData();
    }
    throttle = new Throttle(500, () => {
      ++state.page;
      getMessageData();
    });
    const onLoad = () => {
      console.log("我执行了");
      throttle.search(null);
    };
    const onShowDetail = (item: any) => {
      if(item.isCircleDel == 1){
        Notify('该内容已不可见')
        return
      }
      Storage.add("tempMessageData", {
        top: document.documentElement.scrollTop || document.body.scrollTop,
        datas: state.messageList,
      });
      router.push({
        path: "/infoDetail/" + item.bizId,
      });
    };
    onBeforeUnmount( async() => {
      await readMessageListApi();
      mitt.emit('updateList')
    });
    return {
      ...toRefs(state),
      initCreateFn,
      onLoad,
      onShowDetail,
    };
  },
});

const useDatas = (state: StateType) => {
  return {
    getMessageData: async function () {
      const result: any = await getMessageListApi({
        page: state.page,
        pageSize: state.pageSize,
      });
      if (result.data.code === 0) {
        let tempList = result.data.data.records;
        state.dataTotal = result.data.data.total;
        if (state.page === 1) {
          state.messageList = tempList;
        } else {
          state.messageList = [...state.messageList, ...tempList];
        }
      }
    },
  };
};
